function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bookmarks_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon/action/bookmarks_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.5 1.66667H13.485C11.835 1.66667 10.5 3.16667 10.5 5.00001H25.5C27.15 5.00001 28.5 6.50001 28.5 8.33334V30L31.5 31.6667V5.00001C31.5 3.16667 30.15 1.66667 28.5 1.66667ZM22.5 11.6667V33.2833L16.185 30.2667L15 29.7L13.815 30.2667L7.5 33.2833V11.6667H22.5ZM7.5 8.33334H22.5C24.15 8.33334 25.5 9.83334 25.5 11.6667V38.3333L15 33.3333L4.5 38.3333V11.6667C4.5 9.83334 5.85 8.33334 7.5 8.33334Z",
  fill: "#F4F4F4"
}));

var SvgBookmarks = function SvgBookmarks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmarks.5c88325d.svg";
export { ForwardRef as ReactComponent };